import { useRef, useState } from "react";
import { Music, Pause } from "lucide-react";

// Soft ambient pad generated with the Web Audio API — no external files.
export default function MusicToggle() {
  const [on, setOn] = useState(false);
  const ctxRef = useRef(null);
  const nodesRef = useRef(null);

  const start = () => {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    const ctx = new Ctx();
    const master = ctx.createGain();
    master.gain.value = 0;
    master.connect(ctx.destination);
    const freqs = [146.83, 220, 293.66];
    const oscs = freqs.map((f) => {
      const o = ctx.createOscillator();
      o.type = "sine";
      o.frequency.value = f;
      const g = ctx.createGain();
      g.gain.value = 0.12;
      o.connect(g);
      g.connect(master);
      o.start();
      return o;
    });
    const lfo = ctx.createOscillator();
    lfo.frequency.value = 0.07;
    const lfoGain = ctx.createGain();
    lfoGain.gain.value = 0.04;
    lfo.connect(lfoGain);
    lfoGain.connect(master.gain);
    lfo.start();
    master.gain.linearRampToValueAtTime(0.09, ctx.currentTime + 2);
    ctxRef.current = ctx;
    nodesRef.current = { master, oscs, lfo };
  };

  const stop = () => {
    const ctx = ctxRef.current;
    if (!ctx) return;
    const { master } = nodesRef.current;
    master.gain.linearRampToValueAtTime(0, ctx.currentTime + 1);
    setTimeout(() => ctx.close(), 1100);
    ctxRef.current = null;
  };

  const toggle = () => {
    if (on) stop();
    else start();
    setOn(!on);
  };

  return (
    <button
      data-testid="music-toggle"
      onClick={toggle}
      aria-label={on ? "Pause ambient sound" : "Play ambient sound"}
      className="fixed bottom-20 right-6 z-40 flex items-center gap-2 rounded-full border border-border bg-white/85 px-4 py-2.5 text-xs tracking-wide text-ink-soft shadow-[0_8px_30px_rgb(0,0,0,0.06)] backdrop-blur-md transition-colors hover:bg-white md:bottom-6"
    >
      {on ? <Pause size={14} /> : <Music size={14} />}
      <span className="font-sans">{on ? "Pause" : "Soft music"}</span>
    </button>
  );
}
